import { Link } from "react-router-dom";
import { CTARow } from "@/components/CTA";
import { SITE } from "@/data/site";

export default function NotFoundPage() {
  return (
    <section className="grain flex min-h-[60vh] items-center bg-navy" data-testid="not-found-page">
      <div className="mx-auto max-w-2xl px-4 py-24 text-center sm:px-6">
        <p className="num-outline font-display text-8xl font-bold">404</p>
        <h1 className="mt-4 font-display text-2xl font-bold text-white sm:text-3xl">
          This Page Has Moved On
        </h1>
        <p className="mx-auto mt-4 max-w-md text-sm leading-relaxed text-slate-300">
          The page you're looking for doesn't exist. Let us help you get where you're going — call {SITE.phoneDisplay} or start below.
        </p>
        <CTARow light className="mt-8 justify-center" testPrefix="not-found" />
        <Link to="/" data-testid="not-found-home-link" className="mt-8 inline-block text-sm text-slate-400 underline-offset-4 transition-colors hover:text-gold hover:underline">
          Return to Homepage
        </Link>
      </div>
    </section>
  );
}
